export default __webpack_public_path__ + "static/media/image.3710b8a3.svg";